import { cn } from '@/lib/utils'
import Image from 'next/image'
import React from 'react'

interface ProductVideoThumbnailProps {
  posterSrc?: string
  isPlaying: boolean
  isActive: boolean
  onClick: () => void
  productTitle: string
}

const ProductVideoThumbnail: React.FC<ProductVideoThumbnailProps> = ({
  posterSrc,
  isPlaying,
  isActive,
  onClick,
  productTitle,
}) => {
  return (
    <button
      className={cn(
        'relative flex items-center justify-center lg:h-14.5 lg:w-11',
        !isActive && 'opacity-50'
      )}
      onClick={onClick}
      aria-label={isPlaying ? 'Pause video' : 'Play video'}
    >
      <div className='relative h-10 w-10'>
        {posterSrc && (
          <Image
            src={posterSrc}
            alt={productTitle + ' video thumbnail'}
            width={40}
            height={40}
            className='block h-10 min-h-10 w-10 min-w-10 rounded border border-neutral-300 object-cover lg:border-0'
            unoptimized
          />
        )}
        <div className='absolute inset-0 flex items-center justify-center bg-black/10'>
          {isPlaying ? (
            <svg
              width='16'
              height='16'
              viewBox='0 0 16 16'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <rect x='4' y='3' width='3' height='10' rx='1' fill='white' />
              <rect x='9' y='3' width='3' height='10' rx='1' fill='white' />
            </svg>
          ) : (
            <svg
              width='16'
              height='16'
              viewBox='0 0 16 16'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path d='M12 8L4 3.5V12.5L12 8Z' fill='white' />
            </svg>
          )}
        </div>
      </div>
    </button>
  )
}

export default ProductVideoThumbnail
